import setLang from '../lang';

const lang = {
    i: {
        locale: 'zh-TW',

    }
};

setLang(lang);

export default lang;



// WEBPACK FOOTER //
// ./goingsrc/locale/lang/zh-TW.js